module.exports = __webpack_public_path__ + "static/img/risk_nor1.3e32c2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/risk_nor1.png
// module id = 927
// module chunks = 1